"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signSocialTx = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const blake2b_1 = require("@nervosnetwork/ckb-sdk-utils/lib/crypto/blake2b");
const constants_1 = require("../constants");
const secp256r1_1 = require("./secp256r1");
const utils_1 = require("../utils");
const secp256k1_1 = require("./secp256k1");
const js_sha3_1 = require("js-sha3");
const signSocialTx = (servicer, socialMsg, socialUnlockReq, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const witnessGroup = transaction.witnesses;
    if (!witnessGroup.length) {
        throw new Error('WitnessGroup cannot be empty');
    }
    if (typeof witnessGroup[0] !== 'object') {
        throw new Error('The first witness in the group should be type of WitnessArgs');
    }
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(transaction);
    const emptyWitness = Object.assign(Object.assign({}, witnessGroup[0]), { lock: `0x${'0'.repeat(constants_1.SOCIAL_LOCK_LEN)}`, outputType: '0x' });
    const serializedEmptyWitnessBytes = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness));
    const serializedEmptyWitnessSize = serializedEmptyWitnessBytes.length;
    let hasher = (0, blake2b_1.default)(32, null, null, ckb_sdk_utils_1.PERSONAL);
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(socialMsg));
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
    hasher.update(serializedEmptyWitnessBytes);
    witnessGroup.slice(1).forEach(w => {
        const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
        hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
        hasher.update(bytes);
    });
    const message = `${hasher.digest('hex')}`;
    const base64 = Buffer.from(message).toString('base64url');
    const sighashAll = Buffer.from(base64, 'utf8').toString('hex');
    const authData = '49960de5880e8c687434170f6476605b8fe4aeb9a28632c7995cf3ba831d97630162f9fb77';
    const clientData = `7b2274797065223a22776562617574686e2e676574222c226368616c6c656e6765223a22${sighashAll}222c226f726967696e223a22687474703a2f2f6c6f63616c686f73743a38303030222c2263726f73734f726967696e223a66616c73657d`;
    const clientDataHash = (0, secp256r1_1.sha256Hash)(clientData);
    const webAuthnSignData = `0x${authData}${clientDataHash}`;
    emptyWitness.lock = '0x03';
    const socialReq = Object.assign(Object.assign({}, socialUnlockReq), { friends: socialUnlockReq.friends.map((friend) => {
            if (friend.algIndex == 1) {
                const key = (0, utils_1.keyFromPrivate)(friend.privateKey, utils_1.SigAlg.Secp256r1);
                return {
                    lockScript: friend.lockScript,
                    pubkey: friend.pubkey,
                    signature: (0, secp256r1_1.signSecp256r1Message)(key, webAuthnSignData),
                    unlockMode: friend.unlockMode,
                    algIndex: friend.algIndex,
                    webAuthnMsg: `0x${authData}${clientData}`
                };
            }
            else if (friend.algIndex == 2) {
                const hasher = js_sha3_1.keccak_256.create();
                hasher.update((0, ckb_sdk_utils_1.hexToBytes)(socialMsg));
                hasher.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
                hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
                hasher.update(serializedEmptyWitnessBytes);
                witnessGroup.slice(1).forEach(w => {
                    const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
                    hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
                    hasher.update(bytes);
                });
                const message = (0, secp256k1_1.calcEthPersonalHash)(hasher.array());
                const key = (0, utils_1.keyFromPrivate)(friend.privateKey, utils_1.SigAlg.Secp256k1);
                return {
                    lockScript: friend.lockScript,
                    pubkey: friend.pubkey,
                    signature: (0, secp256k1_1.signSecp256k1Message)(key, message),
                    unlockMode: friend.unlockMode,
                    algIndex: friend.algIndex,
                };
            }
            else {
                const key = (0, utils_1.pemToKey)(friend.privateKey);
                return {
                    lockScript: friend.lockScript,
                    pubkey: friend.pubkey,
                    signature: (0, utils_1.signRSAMessage)(key, webAuthnSignData),
                    unlockMode: friend.unlockMode,
                    algIndex: friend.algIndex,
                    webAuthnMsg: `0x${authData}${clientData}`
                };
            }
        }) });
    const { unlockEntry } = yield servicer.aggregator.generateSocialUnlockSmt(socialReq);
    emptyWitness.outputType = `0x${unlockEntry}`;
    const signedWitnesses = [(0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness), ...witnessGroup.slice(1)];
    return Object.assign(Object.assign({}, transaction), { witnesses: signedWitnesses.map(witness => (typeof witness === 'string' ? witness : (0, ckb_sdk_utils_1.serializeWitnessArgs)(witness))) });
});
exports.signSocialTx = signSocialTx;
